import { render, staticRenderFns } from "./DynamicLogger.vue?vue&type=template&id=4bb1183a"
import script from "./DynamicLogger.vue?vue&type=script&lang=js"
export * from "./DynamicLogger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports